import React, { useState, useEffect } from 'react';

import axios from 'axios';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import { useLocation } from 'react-router';

import { Loader } from '@src/components/ui';
import Error401 from '@src/containers/errors/401error';
import Error403 from '@src/containers/errors/403error';
import Error404 from '@src/containers/errors/404error';
import Error500 from '@src/containers/errors/500error';
import { currentJwt } from '@src/utils/jwtHelpers';

const getJsonFromUrl = (searchParams) => {
    const result = {};
    if (!searchParams) return result;
    searchParams.substr(1).split('&').forEach((part) => {
        const item = part.split('=');
        if (item[0]) {
            result[item[0]] = decodeURIComponent(item[1] || '');
        }
    });
    return result;
};

const GetSignedUrlFile = () => {
    const location = useLocation();

    const [file] = useState(() => getJsonFromUrl(location.search));
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    const handleSuccess = (signedHref) => {
        if (signedHref) {
            window.location.href = signedHref;
        }
        setSuccess(true);
    };

    const handleError = (err) => {
        setError(err?.response || err || { status: 500 });
    };

    const getPreSignedUrl = async (id) => {
        const url = `${process.env.API_HOST_URL}/api/v1/attachments/${id}/download`;
        const token = currentJwt();
        const options = {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        };

        return axios.get(url, options);
    };

    useEffect(() => {
        if (!file.id) {
            setError({ status: 404 });
            return;
        }

        getPreSignedUrl(file.id)
            .then((res) => {
                const downloadUrl = res.data?.attachment?.download_url || res.data?.download_url;
                if (downloadUrl) {
                    handleSuccess(downloadUrl);
                } else {
                    handleError({ status: 500 });
                }
            })
            .catch((err) => {
                handleError(err);
            });
    }, [file.id]);

    const renderError = () => {
        if (!error) return <Error500 />;

        switch (error.status) {
        case 401:
            return <Error401 />;
        case 403:
            return <Error403 />;
        case 404:
            return <Error404 type="file" />;
        default:
            return <Error500 />;
        }
    };

    const renderSuccess = (name) => (
        <>
            <h2>Success!</h2>
            <p><strong>{name}</strong> has been downloaded.</p>
            <p>Please check for the file in your default download folder.</p>
        </>
    );

    return (
        <Col xs={12} className="post_page content-container content-view-container">
            <Card>
                <Card.Body>
                    {
                        !success && !error
                        && <Loader />
                    }
                    {
                        (success || error)
                        && <h1>Secure file download</h1>
                    }
                    {
                        !success && error
                        && renderError()
                    }
                    {
                        success
                        && renderSuccess(file.name)
                    }
                </Card.Body>
            </Card>
        </Col>
    );
};

export { GetSignedUrlFile };
